module.exports = __webpack_public_path__ + "static/media/failed.83ea58a5.svg";